module.exports = __webpack_public_path__ + "static/media/img_general_logo.74ecb9d5.svg";